export class LightRow {
  constructor(public values: string[]) {
  }

  /**
   * メモリ対策のため、必要になるまで生成しない
   */
  private selectedStatus: boolean[] = null;

  private createDefaultSelectedStatus(): boolean[] {
    const results: boolean[] = [];
    for (let index = 0; index < this.values.length; ++index) {
      results[index] = false;
    }
    return results;
  }

  public selectRow(): void {
    if (!this.selectedStatus) {
      this.selectedStatus = this.createDefaultSelectedStatus();
    }
    for (let index = 0; index < this.values.length; ++index) {
      this.selectedStatus.splice(index, 1, true);
    }
  }

  public selectCell(index: number, isSelect: boolean): void {
    if (!this.selectedStatus) {
      this.selectedStatus = this.createDefaultSelectedStatus();
    }
    this.selectedStatus.splice(index, 1, isSelect);
  }

  public get isSelected(): boolean {
    if (!this.selectedStatus) { return false; }
    return this.selectedStatus[0];
  }

  public get areCellsSelected(): boolean {
    return this.selectedStatus && this.selectedStatus.some(s => s);
  }

  public isCellSelected(index: number): boolean {
    if (!this.selectedStatus) { return false; }
    return !!this.selectedStatus[index];
  }

  public clearSelection(): void {
    if (!this.selectedStatus) { return; }
    for (let index = 0; index < this.selectedStatus.length; ++index) {
      if (this.selectedStatus[index]) {
        this.selectedStatus.splice(index, 1, false);
      }
    }
  }
}
